/** Rota da vitrine de moeda. Igual à vitrine de gamificação, ela precisa subir
 *  sem sonda de API, sem service worker e sem prefetch — é uma página de
 *  revisão visual, não uma tela do produto. */
const CURRENCY_SHOWCASE_PATH = "/moeda-showcase";

export function isCurrencyShowcasePath(pathname: string): boolean {
  const normalized = pathname.replace(/\/+$/, "") || "/";
  return normalized === CURRENCY_SHOWCASE_PATH;
}

export { CURRENCY_SHOWCASE_PATH };
